import React from "react";
import { useAuth } from "shared/context/auth";
import { isEmpty } from "shared/utils";
import { useGetDashboardDetails } from "./dataloader";
import { MyExperienceDashboardContext } from "./types";
import { ApiRegistrationParticipantForDashboardDetails } from "../../../../shared/types/ApiRegistrationParticipantForDashboardDetails";

const DashboardContext = React.createContext<MyExperienceDashboardContext>({} as MyExperienceDashboardContext);

export default function MyExperienceDashboard(props: any) {
  const { userDetail } = useAuth();
  const { data, refetch } = useGetDashboardDetails({
    regParticipantId: userDetail?.id
  });

  const dashboardData: MyExperienceDashboardContext = React.useMemo(
    () => ({
      data: data as ApiRegistrationParticipantForDashboardDetails,
      refetch
    }),
    [data, refetch]
  );

  if (!data) {
    return null;
  }

  return <DashboardContext.Provider value={dashboardData}>{props.children}</DashboardContext.Provider>;
}

function useMyExperienceDashboardDetails() {
  const context = React.useContext(DashboardContext);
  if (isEmpty(context)) {
    throw new Error(`useMyExperienceDashboardDetails must be used within a DashboardContext`);
  }
  return context;
}

export { useMyExperienceDashboardDetails };
